import { useEffect, useRef, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGlobal } from 'legacyfrontend/contexts/GlobalContext';
import { ROUTE_KEYS } from 'legacyfrontend/constants';
import {
  selectTemplateData,
  selectFirstActiveRoute,
  selectHasActiveSearchers,
} from 'legacyfrontend/redux/selectors/application-selectors';
import BannersComponents from 'legacyfrontend/components/home/BannersComponents';
import { Seo } from 'core/components/seo';
import { useAppName } from 'legacyfrontend/hooks/useSafeState';

const { HOME } = ROUTE_KEYS;

const HomeView = () => {
  const history = useHistory();
  const location = useLocation();
  const { onSearchCount } = useGlobal();
  const hasRedirected = useRef(false);
  const appName = useAppName();

  const templateData = useSelector(selectTemplateData);
  const firstActiveRoute = useSelector(selectFirstActiveRoute);
  const hasActiveSearchers = useSelector(selectHasActiveSearchers);

  const orgJsonLd = useMemo(() => {
    if (!appName) return null;
    const ld = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: appName,
      description:
        'Reservá tus vacaciones y paquetes turísticos con los mejores precios y financiación. Vuelos, hoteles, traslados y excursiones.',
    };
    if (typeof window !== 'undefined') {
      ld.url = window.location.origin;
    }
    return ld;
  }, [appName]);

  useEffect(() => {
    if (
      location.pathname === HOME &&
      onSearchCount === 0 &&
      !hasRedirected.current &&
      templateData &&
      firstActiveRoute !== HOME &&
      hasActiveSearchers
    ) {
      hasRedirected.current = true;
      history.replace(firstActiveRoute);
    }
  }, [
    location.pathname,
    onSearchCount,
    history,
    templateData,
    firstActiveRoute,
    hasActiveSearchers,
  ]);

  if (!hasActiveSearchers) {
    return (
      <>
        <Seo
          title={`${appName} — Viajes y Paquetes Turísticos`}
          description={`${appName} — Reservá tus vacaciones y paquetes turísticos con los mejores precios y financiación. Vuelos, hoteles, traslados y excursiones.`}
          jsonLd={orgJsonLd}
        />
        {/* Luiggi corroborar si este h1 es necesario {appName && (
          <h1 style={{ fontSize: '1.75rem', fontWeight: 700, margin: '1rem 1rem 0.5rem', lineHeight: 1.3 }}>
            {appName}
          </h1>
        )} */}
        {appName && (
          <h1 className='sr-only'>{appName} — Viajes y Paquetes Turísticos</h1>
        )}
        <BannersComponents />
      </>
    );
  }

  return (
    <>
      <Seo
        title={`${appName} — Viajes y Paquetes Turísticos`}
        description={`${appName} — Reservá tus vacaciones y paquetes turísticos con los mejores precios y financiación. Vuelos, hoteles, traslados y excursiones.`}
        jsonLd={orgJsonLd}
      />
      {appName && (
        <h1 className='sr-only'>{appName} — Viajes y Paquetes Turísticos</h1>
      )}
    </>
  );
};

export default HomeView;
